import styled from "styled-components";

export const Footer = styled.footer`
  width: 100%;
  height: auto;
  color: #fff;
  background-color: #252525;

  .footer_section {
    padding: 40px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
      row-gap: 50px;
    }

    .section_width {
      width: 25%;
      padding: 0 20px;
      font-size: 14px;
      line-height: 1.6;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
      }

      h3 {
        margin-bottom: 20px;
        font-family: "Roboto", sans-serif;
      }
    }

    .section_1 {
      p {
        font-weight: 300;
        opacity: 0.7;
      }
      .social_icons {
        display: flex;
        justify-content: flex-start;
        a {
          color: #fff;
          margin-right: 10px;
          font-size: 16px;
          margin-top: 30px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: #434343ff;
          display: flex;
          justify-content: center;
          align-items: center;
          text-decoration: none;
        }
      }
    }
    .section_2 {
      li {
        list-style: none;
        a {
          text-decoration: none;
          color: #fff;
          line-height: 1.8;
          font-weight: 300;
          &:hover {
            color: gold;
            cursor: pointer;
          }
        }
        i {
          margin-right: 10px;
          font-size: 12px;
        }
      }
    }
    .section_3 {
      li {
        list-style: none;
        display: table;
        margin-bottom: 10px;
        font-weight: 300;
        cursor: pointer;
        &:hover {
          color: gold;
        }
        i {
          margin-right: 20px;
        }
        span {
          display: table-cell;
        }
      }
    }
    .section_4 {
      dl {
        dt {
          margin-top: 15px;
          font-weight: 400;
          opacity: 0.8;
        }
        dd {
          padding-left: 20px;
          font-size: 12px;
          font-weight: 300;
        }
      }
    }
  }
`;
